module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead8-ae8ef7559a57470daa6cc78e02d97eb5.jpg";